import React from 'react'
import { createEvent } from 'ics'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'

const AddToCalendarButton = React.forwardRef(function AddToCalendarButton(
  props,
  ref,
) {
  const {
    event: calendarEvent,
    icon,
    children,
    trigger,
    ...buttonProps
  } = props
  const downloadIcsFile = () => {
    const icsArgs = {
      uid: calendarEvent.uid,
      start: calendarEvent.startDateTime
        .toFormat('y-M-d-H-m')
        .split('-')
        .map(n => parseInt(n)),
      end: calendarEvent.endDateTime
        .toFormat('y-M-d-H-m')
        .split('-')
        .map(n => parseInt(n)),
      title: calendarEvent.title,
      description: calendarEvent.description,
      location: calendarEvent.location,
      url: calendarEvent.url,
      status: 'CONFIRMED',
      busyStatus: 'BUSY',
      organizer: calendarEvent.organizer,
      attendees: calendarEvent.attendees,
    }
    createEvent(icsArgs, (error, value) => {
      if (!error) {
        const reader = new FileReader()
        const out = new Blob([value], { type: 'text/calendar' })
        reader.onload = function () {
          window.location.href = reader.result
        }
        reader.readAsDataURL(out)
      }
    })
  }
  const handleClick = clickEvent => {
    buttonProps.onClick?.(clickEvent)
    downloadIcsFile()
  }

  if (trigger) {
    const triggerOnClick = trigger.props.onClick
    const isNativeButton =
      trigger.type === 'button' ||
      trigger.props?.component === 'button' ||
      trigger.props?.type === 'button'

    const handleTriggerClick = clickEvent => {
      triggerOnClick?.(clickEvent)
      if (!clickEvent?.defaultPrevented) {
        handleClick(clickEvent)
      }
    }

    const handleTriggerKeyDown = keyEvent => {
      trigger.props.onKeyDown?.(keyEvent)
      if (keyEvent.defaultPrevented || isNativeButton) {
        return
      }

      if (keyEvent.key === 'Enter' || keyEvent.key === ' ') {
        keyEvent.preventDefault()
        handleClick(keyEvent)
      }
    }

    return React.cloneElement(trigger, {
      onClick: handleTriggerClick,
      onKeyDown: handleTriggerKeyDown,
      ref,
      ...(isNativeButton
        ? {}
        : {
          role: trigger.props.role || 'button',
          tabIndex: trigger.props.tabIndex ?? 0,
        }),
    })
  }

  const IconComponent = icon?.type ?? icon
  return icon ? (
    <IconButton ref={ref} {...buttonProps} onClick={handleClick}>
      <IconComponent {...(icon.props || {})} />
    </IconButton>
  ) : (
    <Button ref={ref} {...buttonProps} onClick={handleClick}>
      {children}
    </Button>
  )
})

export default AddToCalendarButton
